import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noSelectedRolesLabel: {
		id: 'feature-gates-tmp-access.feature-gated-roles-picker.no-selected-roles-label',
		defaultMessage: '-',
		description:
			'Label shown in the trigger button for the user roles picker when the user has no roles assigned',
	},
	openRolesPicker: {
		id: 'feature-gates-tmp-access.feature-gated-roles-picker.open-roles-picker',
		defaultMessage: 'Open user roles picker',
		description:
			'Used as an icon label for a dropdown trigger button. The trigger button opens a dropdown for modifying user roles',
	},
});
